import React from 'react';
import { connect } from 'react-redux';
import { Button, Modal } from 'react-bootstrap';

import { translate } from 'react-i18next';
import SCEditor from '../../components/sc_editor/SCEditor';
import { SCControlPanel } from '../../components/sc_editor/SCControlPanel';
import { editWindowAndShadingDevices } from '../../redux/section/section_component_actions';
import { defaultRejectHandler } from '../../utils/utility';

class SCEditorModal extends React.Component {
  constructor(props) {
    super(props);

    try {
      const structureJson = JSON.parse(this.props.sectionComponent.shading_device_0);
      this.window = structureJson.window;
      this.shadingDevices = structureJson.shadingDevices;
    } catch (e) {
      const sideLength = Math.sqrt(this.props.sectionComponent.area).toFixed(2);
      this.window = { width: sideLength, height: sideLength };
      this.shadingDevices = {
        left: [],
        right: [],
        top: [],
        front: [],
      };
    }

    try {
      const scJson = JSON.parse(this.props.sectionComponent.shading_device_1);
      this.SC = {
        beam: scJson.beam,
        diffuse: scJson.diffuse,
        total: scJson.total,
      };
    } catch (e) {
      this.SC = {};
    }

    this.editorRef = null;
  }

  componentWillUnmount() {
    // Clear localStorage cache when modal is closed
    SCControlPanel.clearStorageCache();
  }

  onSaveHandler() {
    const {
      area,
      SC,
      rawSC,
      structure,
    } = this.editorRef.getWrappedInstance().getData();
    // Clear localStorage cache after save
    SCControlPanel.clearStorageCache();
    this.props.save(area, SC, rawSC, structure);
  }

  render() {
    const {
      isEditing,
      sectionComponent,
      azimuth,
      save,
      errorMessage,
      t,
      ...newProps
    } = this.props;

    return (
      <Modal
        {...newProps}
        dialogClassName="sc-editor-modal-fullscreen"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('SC calculator')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SCEditor
            sectionComponentId={sectionComponent.id}
            azimuth={azimuth}
            window={this.window}
            shadingDevices={this.shadingDevices}
            SC={this.SC}
            t={t}
            ref={ref => (this.editorRef = ref)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            disabled={isEditing}
            onClick={() => this.onSaveHandler()}
          >
            {isEditing ? `${t('saving')}...` : t('save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isEditing: state.section_component.isEditing,
});

const mapDispatchToProps = (dispatch, { sectionComponent }) => ({
  save: (area, SC, rawSC, structure) =>
    defaultRejectHandler(dispatch(editWindowAndShadingDevices(sectionComponent.id, area, SC, rawSC, structure))),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(SCEditorModal),
);



// WEBPACK FOOTER //
// ./src/modal/sc_editor/SCEditorModal.js